import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/index.ts';
import App from './App.tsx';
import './index.css';
import './i18n/config'; // ⭐ Inicializar i18n

/**
 * Data router configuration
 * 
 * Uses createBrowserRouter to enable data router features like useBlocker.
 * The App component handles all route definitions internally using <Routes>.
 */
const router = createBrowserRouter([
  {
    path: '*',
    element: <App />,
  },
]);


const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>,
);
